/**
 * The token a mailed link carries — `/email/verify`, `/invitations/accept` — read one way for
 * both.
 *
 * **The fragment first, the query second.** survey-api mints `#token=`, never `?token=`:
 * `docker/nginx.conf` sets no `access_log` directive, so the default `combined` format records the
 * full request line of every hit, and a query string would put a live single-use credential into
 * the server's logs. A fragment is never sent to the server, nor as a `Referer`. The query is still
 * read, second, so a link someone rebuilt by hand still works; nothing in this app mints one.
 *
 * The value is answered raw — a caller trims it or not — and the URL is left as it is: the token
 * exists nowhere else, so a reload must still find it.
 */
export function tokenFromLink(hash: string, search: string): string {
  return (
    new URLSearchParams(hash.replace(/^#/, '')).get('token') ??
    new URLSearchParams(search).get('token') ??
    ''
  );
}
